export default __webpack_public_path__ + "static/media/logo.703ddac9.png";